<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">
            收起查询
          </el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">
            展开查询
          </el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-flod-content-order common-search-formtype search-input-group">
            <el-form :inline="true" :model="formInlineTmp" class="search-content-item" label-width="100px">
              <el-form-item label="订单编号:">
                <el-input v-model="formInlineTmp.order_number" placeholder="请输入订单编号" clearable></el-input>
              </el-form-item>
              <el-form-item label="商品名称:">
                <el-input v-model="formInlineTmp.name" placeholder="请输入商品名称" clearable></el-input>
              </el-form-item>
              <el-form-item label="客户ID:">
                <el-input v-model="formInlineTmp.fans_id" placeholder="请输入客户ID" clearable></el-input>
              </el-form-item>
              <el-form-item label="收货人:">
                <el-input v-model="formInlineTmp.consignee_name" placeholder="请输入收货人姓名" clearable></el-input>
              </el-form-item>
              <el-form-item label="开始时间:">
                <el-date-picker
                  v-model="formInlineTmp.start"
                  type="datetime"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间:">
                <el-date-picker
                  v-model="formInlineTmp.end"
                  type="datetime"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="收货电话:">
                <el-input v-model="formInlineTmp.consignee_number" placeholder="请输入收货人电话" clearable></el-input>
              </el-form-item>
              <el-form-item label="订单状态:">
                <el-select v-model="formInlineTmp.order_status" placeholder="请选择">
                  <el-option
                    v-for="item in orderStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="exportAction" class="add-btn" style="float: right;">导出</el-button>
        <el-button type="primary" class="add-btn" style="float: right;margin-right:16px" @click="getIntegralSync">订单同步 </el-button>
        <el-button type="primary" class="add-btn" style="float: right;margin-right:16px" @click="getDeliverSync">发货同步</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-checkbox-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <!--<el-table-column
          type="selection"
          width="30">
        </el-table-column>-->
         <!-- <el-table-column
          label="序号"
          width="100">
          <template slot-scope="scope">
            <span class="text-grey"> {{ scope.$index + 1}}</span>
          </template>
        </el-table-column> -->
          <el-table-column
          width="32">
          </el-table-column>
        <el-table-column
          prop="order_number"
          width="200"
          label="订单编号">
        </el-table-column>
        <el-table-column
          prop="pro_code"
          label="商品编码"
          width="140">
        </el-table-column>
        <el-table-column
          prop="pro_name"
        label="商品名称">
           <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.pro_name }}</p>
              <div slot="reference" class="name-wrapper">
                {{ scope.row.pro_name }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          width=""
          prop="waste_integral"
          label="使用积分">
        </el-table-column>
        <el-table-column
          prop="fans_id"
          width=""
          label="客户ID">
        </el-table-column>
        <el-table-column
          prop="name"
          width=""
          label="收货人">
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="收货电话"
          width="">
        </el-table-column>
        <el-table-column
          prop="consignee_address"
          label="收货地址">
          <template slot-scope="scope">
            <div>{{scope.row.province}}{{scope.row.city}}{{ scope.row.district}}</div>
            <!-- <div v-else>{{ scope.row.consignee_address }}</div> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          width=""
          label="订单时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          width=""
          label="订单状态">
          <!-- '订单状态- 1订单删除 0交易关闭 1待付款 2待发货 3待收货 4交易成功 -->
          <template slot-scope="scope">
            <div v-if="scope.row.order_status === 0">交易关闭</div>
            <div v-if="scope.row.order_status === 1">待付款</div>
            <div v-if="scope.row.order_status === 2">待发货</div>
            <div v-if="scope.row.order_status === 3">已发货</div>
            <div v-if="scope.row.order_status === 4">交易成功</div>
          </template>
        </el-table-column>
        <el-table-column
          width=""
          prop="logistics_number"
          label="物流单号">
        </el-table-column>
        <!--<el-table-column label="操作" width="70" style="display: flex;justify-content: center">-->
          <!--<template slot-scope="scope">-->
            <!--<el-tooltip class="item" effect="dark" content="编辑" placement="bottom">-->
              <!--<div v-if="scope.row.order_status === 2" class="op-link" @click="changeOrderStatusAction(scope.row.id)">-->
                <!--发货-->
                <!--&lt;!&ndash; <i class="iconfont icon-icon-bianji" style="font-size: 14px" @click="pushToInfoManage(scope.row.id)"> &ndash;&gt;-->
                <!--&lt;!&ndash; </i> &ndash;&gt;-->
              <!--</div>-->
            <!--</el-tooltip>-->
          <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getProductOrderList, getIntegralSync, getDeliverSync, changeOrderStatus, exportProductOrder } from '@/api/customer.js'
export default {
  name: '',
  data () {
    return {
      loading: true,
      formInlineTmp: {
        order_number: '',
        order_status: '',
        name: '',
        fans_id: '',
        consignee_number: '',
        consignee_name: '',
        start: '',
        end: ''
      },
      formInline: {
        order_number: '',
        order_status: '',
        name: '',
        fans_id: '',
        consignee_number: '',
        consignee_name: '',
        start: '',
        end: ''
      },
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      orderStatusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '待发货',
          value: '2'
        },
        {
          label: '已发货',
          value: '3'
        },
        {
          label: '交易成功',
          value: '4'
        }
      ]
    }
  },
  methods: {
    searchData() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      console.log('this.formInline', this.formInline)
      this.getData()
    },
    judgeDate() {
      if (this.formInline.start !== undefined && this.formInline.end !== undefined) {
        let test = new RegExp('/-/g')
        let d1 = new Date(this.formInline.start.replace(test, '/'))
        let d2 = new Date(this.formInline.end.replace(test, '/'))
        if (d1 > d2) {
          _g.toastMsg('error', '开始时间不能大于结束时间!')
          return false
        }
      }
    },
    exportAction() {
      exportProductOrder(this.formInline).then(res => {
        this.download(res)
      })
    },
    // 是否发货
    // changeOrderStatusAction(id) {
    //   this.$confirm('确认发货?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     changeOrderStatus(id, 3).then(res => {
    //       if (res.data.code === 0) {
    //         _g.toastMsg('success', res.data.error)
    //       } else {
    //         _g.toastMsg('error', res.data.error)
    //       }
    //       this.getData()
    //     })
    //   }).catch((error) => {
    //     console.log(error)
    //   })
    // },
    pushToInfoManage() {
      router.push('/home/member-info-manage')
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    getData() {
      if ((this.formInline.start !== undefined && this.formInline.end !== undefined) && (this.formInline.start !== null && this.formInline.end !== null)) {
        if (this.judgeDate() === false) {
          return
        }
      }
      this.loading = true
      if (this.formInline.consignee_number !== '') {
        let mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/
        if (!mobile.test(this.formInline.consignee_number)) {
          _g.toastMsg('error', '请填入正确手机号')
          return
        }
      }
      getProductOrderList(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.total
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 订单同步
    getIntegralSync() {
      _g.toastMsg('success', '正在同步订单')
      getIntegralSync().then(res => {
        this.getData()
        if (res.data.code === 0) {
          _g.toastMsg('success', '订单同步成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 发货同步
    getDeliverSync() {
      _g.toastMsg('success', '正在同步发货')
      getDeliverSync().then(res => {
        this.getData()
        if (res.data.code === 0) {
          _g.toastMsg('success', '发货同步成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    }
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.name-wrapper {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.search-flod-content-order {
  padding: 10px;
  background-color: #fff;
}
</style>
